import dynamic from "next/dynamic";

export const DevineBirthday = dynamic(import("../organisms/DevineBirthday"));
export const DevineMatch = dynamic(() => import("../organisms/DevineMatch"));
export const DevineTarot = dynamic(() => import("../organisms/DevineTarot"));
export const Fortune = dynamic(() => import("../organisms/Fortune"));
export const LargeHeader = dynamic(() => import("./LargeHeader"));
export const Link = dynamic(() => import("./Link"));
export const MediumHeader = dynamic(() => import("./MediumHeader"));
export const Movie = dynamic(() => import("./Movie"));
export const Quiz = dynamic(() => import("./Quiz"));
export const SmallHeader = dynamic(
  async () => (await import("../molecules/SmallHeader")).SmallHeader
);
export const TableOfContents = dynamic(
  () => import("../molecules/TableOfContents")
);
export const Text = dynamic(() => import("./Text"));
export const TextOfFortuneTeller = dynamic(
  () => import("../molecules/TextOfFortuneTeller")
);
export const Topic = dynamic(() => import("./Topic"));
export const TopicImage = dynamic(() => import("../molecules/TopicImage"));
export const LinkButton = dynamic(() => import("../molecules/LinkButton"));
export const LinkButton2 = dynamic(() => import("../molecules/LinkButton2"));
export const Quote = dynamic(() => import("../molecules/Quote"));
export const FreeFortuneBotLink = dynamic(
  async () =>
    (await import("../organisms/FreeFortuneBotLink")).FreeFortuneBotLink
);
